import React from "react"
// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import type { InputProps } from "@chakra-ui/react"
// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react"
import { useController, useFormContext } from "react-hook-form"
import { useColors, componentStyles } from "@mallardbay/lib-react-components"
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import HookFormControl from "~components/shared/hook-form/core/hook-form-control"

interface Props extends InputProps {
    readonly name: string
    readonly label?: string
    readonly subLabel?: string
    readonly icon?: IconDefinition
}

const INPUT_MODE = "text"

export default function TextControl({
    name,
    label,
    icon,
    subLabel,
    ...inputProps
}: Props) {
    const { control } = useFormContext()

    const {
        field: { name: fieldName, value, onChange, onBlur, ref },
    } = useController({ control, name })

    const styles = useStyles()

    return (
        <HookFormControl
            label={label}
            subLabel={subLabel}
            name={fieldName}
            isRequired={inputProps.isRequired}
        >
            <InputGroup>
                {!!icon && (
                    <InputLeftElement>
                        <FontAwesomeIcon icon={icon} />
                    </InputLeftElement>
                )}
                <Input
                    ref={ref}
                    aria-label={label}
                    name={fieldName}
                    inputMode={INPUT_MODE}
                    value={value || ""}
                    onChange={(event) => {
                        onChange(event.target.value)
                    }}
                    onBlur={onBlur}
                    {...inputProps}
                    {...styles.input}
                />
            </InputGroup>
        </HookFormControl>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        input: {
            fontSize: "md",
            focusBorderColor: colors.focusBorder,
        },
    })
}
